export default __webpack_public_path__ + "static/media/mini-2.1e6434f7.jpg";